export default __webpack_public_path__ + "static/media/dev-cv.85624070.pdf";